import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Fonts } from '../../../styleConstants';

const SectionTitle = styled.div`
  font-size: ${({ $size }) => $size};
  font-weight: ${Fonts.REGULAR};
  line-height: ${({ $lineHeight }) => $lineHeight};
  color: ${({ $color }) => $color};
`;

SectionTitle.propTypes = {
  $size: PropTypes.string,
  $lineHeight: PropTypes.string,
  $color: PropTypes.string
};

SectionTitle.defaultProps = {
  $size: '64px',
  $lineHeight: Fonts.PARA_LINE_HEIGHT,
  $color: '#1f2432'
};

export default SectionTitle;
